module.exports = __webpack_public_path__ + "img/online_radio.1b03a3cb.svg";